export const keyName = {
  RIGHT_ARROW: 'ArrowRight',
  LEFT_ARROW: 'ArrowLeft'
}
